import type { ClientOrder } from "../services/clientApi.service";

export type ServiceType = "MEAL_DELIVERY" | "CATERING";

export interface OrderReplayItem {
  productId: string;
  productName: string;
  unitPrice: number;
  quantity: number;
  isSwitch?: boolean;
}

export interface OrderReplayDay {
  deliveryDate: string;
  specialInstructions?: string | null;
  items: OrderReplayItem[];
}

/** État passé à `/client/order/new` pour préremplir le panier. */
export interface ClientOrderReplayState {
  serviceType: ServiceType;
  customerAddressId?: string | null;
  orders: OrderReplayDay[];
}

export function buildReplayFromOrders(orders: ClientOrder[]): ClientOrderReplayState | null {
  if (orders.length === 0) return null;
  const first = orders[0];
  return {
    serviceType: first.serviceType,
    customerAddressId: first.customerAddressId,
    orders: orders.map((order) => ({
      deliveryDate: order.deliveryDate.slice(0, 10),
      specialInstructions: order.specialInstructions,
      items: order.items.map((it) => ({
        productId: it.productId,
        productName: it.product.name,
        unitPrice: Number(it.unitPrice),
        quantity: it.quantity,
        isSwitch: it.isSwitch ?? false,
      })),
    })),
  };
}

export function buildReplayFromOrder(order: ClientOrder): ClientOrderReplayState {
  return buildReplayFromOrders([order])!;
}
